function selectElements<T extends Element = Element>(selectors: string): NodeListOf<T> {
  return document.querySelectorAll<T>(selectors);
}

function handleSmoothScrollLinkClick(event: Event) {
  event.preventDefault();

  const link = event.currentTarget as HTMLAnchorElement;

  const targetElementId = link.getAttribute('href')?.slice(1);
  if (!targetElementId) return;

  const targetElement = document.getElementById(targetElementId);
  const offset = parseInt(link.getAttribute('data-offset') || '0', 10);

  if (targetElement) {
    const targetOffsetTop = targetElement.offsetTop - offset;
    window.scrollTo({
      top: targetOffsetTop,
      behavior: 'smooth',
    });
  }
}

const smoothScrollLinks = selectElements<HTMLAnchorElement>('.smooth-scroll-link');

smoothScrollLinks.forEach((link) => {
  link.addEventListener('click', handleSmoothScrollLinkClick);
});
